import * as React from "react";
import { useState } from "react";
import { Progress } from "antd";
import { useNavigate } from "react-router-dom";
import { usePointCard } from "@njoy/controller";
import Template from "../../components/layouts/Template";
import Badge from "../../assets/svg/badgeicon.svg";
import IdCard from "../../assets/profile/id-card.svg";
import ReferralIcon from "../../assets/profile/referralIcon.svg";
import Redemptionicon from "../../assets/profile/redemptionIcon.svg";
import PersonalDetail from "../../assets/profile/personal-detail.svg";
// import TopUp from "../../assets/profile/top-up.svg";
import Settings from "../../assets/profile/settings.svg";
import Help from "../../assets/profile/help.svg";
import Legal from "../../assets/profile/legal.svg";
import Logout from "../../assets/profile/logout.svg";
import New from "../../assets/profile/New.svg";
import PurpleNjoy from "../../assets/profile/purpleNjoy.svg";
import Explorer from "../../assets/profile/explorer.svg";
import Insider from "../../assets/profile/insider.svg";
import Gold from "../../assets/profile/gold.svg";
import Black from "../../assets/profile/black.svg";
import * as ROUTES from "../../constants/routes";
import { LogoutModal } from "../../components/modals/logoutModal";

export const ProfilePage: React.FC = () => {
  const navigate = useNavigate();
  const [isLogoutModalVisible, setLogoutModalVisible] = useState(false);
  const {
    customerTier,
    pointBalance,
    tiers,
    pointsForNextTier,
    loading: pointsCardLoading,
  } = usePointCard();

  const progressPercent = Math.min(
    (pointBalance / (pointBalance + pointsForNextTier)) * 100,
    100,
  );

  return (
    <Template page={5}>
      <div className="flex flex-col items-center pb-16 rounded-xl overflow-y-auto">
        {/* Points section */}
        <div className="w-full rounded-[10px] p-5 bg-[linear-gradient(180deg,_#FFFFFF_0%,_#C7D0FF_100%)]">
          <div className="flex items-center justify-between">
            <div className="flex gap-1 items-center mb-3">
              <img src={Badge} alt="" width={17} height={18} />
              <p className="text-[#353535] font-extrabold text-base">
                Point Balance
              </p>
            </div>
            <div
              className="flex items-center gap-1 justify-end text-[#353535]  text-xs mb-3 cursor-pointer"
              onClick={() => navigate(ROUTES.POINTS_OVERVIEW)}
            >
              Check Activity <span aria-hidden="true">›</span>
            </div>
          </div>

          <div
            className="bg-[#353535] rounded-[8px] cursor-pointer"
            onClick={() => navigate(ROUTES.POINTS_OVERVIEW)}
          >
            <div className=" p-4 flex flex-col gap-2 ">
              <div className="flex justify-end items-center  gap-1">
                <img
                  src={
                    customerTier === "Explorer"
                      ? Explorer
                      : customerTier === "Insider"
                        ? Insider
                        : customerTier === "Gold"
                          ? Gold
                          : Black
                  }
                  alt=""
                  width={18}
                  height={18}
                />
                <p className="text-base text-white font-extrabold">
                  {pointsCardLoading ? "..." : customerTier}
                </p>
              </div>
              <div className="flex justify-between items-end mt-2">
                <div className="flex flex-col gap-1">
                  <p className="text-xs text-white">Your Current Points</p>

                  <div className="flex items-center gap-1">
                    <img src={PurpleNjoy} alt="debit" width={13} height={11} />
                    <h2 className="text-2xl text-white font-extrabold">
                      {pointsCardLoading ? "..." : pointBalance}
                    </h2>
                  </div>
                </div>
                <div className="mb-[6px] text-xs bg-[linear-gradient(180deg,_#FFFFFF_0%,_#C7D0FF_100%)] text-[#353535] px-2 py-[2px] rounded-md inline-block ">
                  {pointsCardLoading ? "..." : pointsForNextTier} points to{" "}
                  <span className="bg-[linear-gradient(270deg,_#FF8800_0%,_#FF165C_100%)] bg-clip-text text-transparent font-bold">
                    {pointsCardLoading
                      ? "..."
                      : tiers.find(
                          (cur) =>
                            cur.threshold === pointBalance + pointsForNextTier,
                        )?.name}{" "}
                    Tier
                  </span>
                </div>
              </div>
              
              <Progress
                percent={progressPercent}
                showInfo={false}
                strokeColor={{
                  "0%": "#3B82F6",
                  "100%": "#A855F7",
                }}
                trailColor="#4B5563"
                strokeWidth={8}
                className="mb-2"
                style={{ transition: "all 0.3s ease" }}
              />
            </div>
          </div>
        </div>
        {/* </ShareWrapper> */}

        <div className="flex flex-col gap-[10px] mt-[14px] w-full">
          <button
            onClick={() => navigate(ROUTES.MANAGE_ID_CARDS)}
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#171820] disabled:hover:border-[#171820]"
          >
            <img src={IdCard} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Manage ID Cards</p>
          </button>
          <button
            onClick={() => navigate(ROUTES.REDEMPTION_HISTORY)}
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#171820] disabled:hover:border-[#171820]"
          >
            <img src={Redemptionicon} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Redemption History</p>
            <img src={New} alt="debit" width={30} height={16} />
          </button>
          <button
            onClick={() => navigate(ROUTES.REFERRAL)}
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#171820] disabled:hover:border-[#171820]"
          >
            <img src={ReferralIcon} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Referral</p>
            <img src={New} alt="debit" width={30} height={16} />
          </button>
          <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#171820] disabled:hover:border-[#171820]"
            onClick={() => navigate(ROUTES.PERSONAL_DETAILS)}
          >
            <img src={PersonalDetail} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Personal Details</p>
          </button>
          <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#171820] disabled:hover:border-[#171820]"
            onClick={() => navigate(ROUTES.ACCOUNT_DETAILS)}
          >
            <img src={IdCard} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Account Details</p>
          </button>
          {/* <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#171820] disabled:hover:border-[#171820]"
            onClick={() => navigate(ROUTES.TOP_UP_LIMIT)}
          >
            <img src={TopUp} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Transaction Limit</p>
          </button> */}
          <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#171820] disabled:hover:border-[#171820]"
            onClick={() => navigate(ROUTES.APP_SETTINGS)}
          >
            <img src={Settings} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">App Settings</p>
          </button>

          <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg"
            onClick={() => navigate(ROUTES.HELP_AND_SUPPORT)}
          >
            <img src={Help} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Help & Support</p>
          </button>
          <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg"
            onClick={() => navigate(ROUTES.LEGAL)}
          >
            <img src={Legal} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Legal</p>
          </button>
          <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#760000] backdrop-blur-sm hover:bg-[#bd0b0b] hover:border-[#bd0b0b] focus:ring-[#bd0b0b] rounded-lg"
            onClick={() => setLogoutModalVisible(true)}
          >
            <img src={Logout} alt="debit" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Logout</p>
          </button>
        </div>
        <LogoutModal
          visible={isLogoutModalVisible}
          onCancel={() => setLogoutModalVisible(false)}
          onOk={() => navigate(ROUTES.LOGOUT)}
        />
      </div>
    </Template>
  );
};
